import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewalldailogComponent } from '../viewalldailog/viewalldailog.component';
import { VideostreamingComponent } from '../videostreaming/videostreaming.component';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { ErrorService } from '../error.service';

@Component({
  selector: 'app-totaldvr-dialog',
  templateUrl: './totaldvr-dialog.component.html',
  styleUrls: ['./totaldvr-dialog.component.scss']
})
export class TotaldvrDialogComponent implements OnInit {
  list: any;
  data1: any;
  active: boolean = false;
  searchkey: string = '';
  public searchTerm: string = '';
  card: boolean = false;
  data2: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<TotaldvrDialogComponent>, public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService,private dailog: MatDialog,private errorService: ErrorService) { }
  ngOnInit(): void {
    console.log('data11', this.data);
    this.spinner.show();
    this.campuscctvserviceservice.gettotaldvr().subscribe(

      {
        next:(res) => {
          this.list = res;
          this.spinner.hide();
          console.log('list', this.list);
          this.spinner.show();
          this.data1 = this.list.cctvDvrDetails.filter((a: any) => {
            if (a.cctvDetId === this.data.cctvDetId) {
              return a
            }
            this.spinner.hide();
          });
          console.log('data1', this.data1);
        },
        error: (error: any) => {
          this.spinner.hide();
          this.errorService.errorDisplay(Number(error.status), "Error", "");
        }
      }
  );
  }

  search(event: any) {
    this.searchTerm = (event.target as HTMLInputElement).value;
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }

  toggleClass(data: any) {
    this.spinner.show();
    this.active = !this.active;
    this.card = !this.card;
    console.log(data);
    this.campuscctvserviceservice.viewall(data.cctvDetId).subscribe(res => {
      this.data2 = res;
      this.spinner.hide();
      console.log('data2', this.data2);
    });

  }

  openDialog(data: any) {
    this.dailog.open(ViewalldailogComponent, {
      data: data,
      height: '100%',
      width: '38%',
      position: { right: '0px', top: '0px' }
    });
  }


  backside() {
    this.card = false;
    this.dialogRef.close();
  }

  openvideostreaming(frame: any) {
    this.spinner.show();
    this.dailog.open(VideostreamingComponent, {
      data: frame,
      width: '90%', height: '80%',
    });
    this.spinner.hide();
  }
  
}
